import React, { FC, useEffect } from 'react';

import { Radio, Row } from 'antd';
import { config } from 'config/config';
import { ICheckoutData } from 'src/components/challenge/ChallengeCheckout';
import SelectorWrapper from 'src/components/general/ScrollableSelector';
import ProductItem from 'src/components/ProductItem';
import { ResourceTypeEnum } from 'src/shared/enums';
import {
  IChallengeCheckout,
  IChallengeCheckoutProduct,
} from 'src/shared/models';

export interface ICheckoutProductProps {
  checkoutData: ICheckoutData;
  config: IChallengeCheckout;
  setCheckoutData: React.Dispatch<React.SetStateAction<ICheckoutData>>;
  singleProduct: boolean;
}

const ProductSelector: FC<ICheckoutProductProps> = (props): JSX.Element => {
  const { PLATFORM } = config.APP;
  const {
    checkoutData,
    config: { arrProducts, lead },
    setCheckoutData,
    singleProduct,
  } = props;

  const getIhrez = (item: IChallengeCheckoutProduct): string => {
    let platformCountry = 'LIC';
    switch (PLATFORM) {
      case 'con-ar':
        platformCountry = platformCountry.concat('AR');
        break;
      case 'con-br':
        platformCountry = platformCountry.concat('BR');
        break;
      case 'con-cl':
        platformCountry = platformCountry.concat('CL');
        break;
      case 'con-co':
        platformCountry = platformCountry.concat('CO');
        break;
      case 'con-de':
        platformCountry = platformCountry.concat('DE');
        break;
      case 'con-it':
        platformCountry = platformCountry.concat('IT');
        break;
      case 'con-mx':
        platformCountry = platformCountry.concat('MX');
        break;
      case 'con-pe':
        platformCountry = platformCountry.concat('PE');
        break;
      case 'con-pt':
        platformCountry = platformCountry.concat('PT');
        break;
      case 'con-fr':
        platformCountry = platformCountry.concat('FR');
        break;
      default:
        platformCountry = platformCountry.concat('ES');
        break;
    }
    return platformCountry.concat(item.idResource.toString());
  };

  useEffect(() => {
    setCheckoutData((prevData) => {
      return {
        ...prevData,
        products: [arrProducts.find((item) => item.idResource).idResource],
        productsEan: [arrProducts.find((item) => item.id).id],
      };
    });
    if (ResourceTypeEnum.CHECKOUT_SUPPLEMENTARY_PRODUCT) {
      setCheckoutData((prevData) => {
        return {
          ...prevData,
          supplementaryProducts: arrProducts
            .filter(
              (item) =>
                item.resourceType ===
                ResourceTypeEnum.CHECKOUT_SUPPLEMENTARY_PRODUCT,
            )
            .map((item) => {
              return {
                POSNR: item.idResource,
                MATNR: item.id,
                KWMENG: item.stock,
                IHREZ: getIhrez(item),
              };
            }),
        };
      });
    }
  }, []);

  const renderElement = (product: IChallengeCheckoutProduct) => {
    if (product.description) {
      return (
        <ProductItem
          key={product.id}
          product={product}
          selected={checkoutData?.products?.includes(product.idResource)}
        />
      );
    }
  };
  return (
    <Row justify="center">
      <div className="product-selector__container">
        {!singleProduct && (
          <p className="product-selector__lead product-selector__lead-product">
            {lead}
          </p>
        )}
        {!singleProduct && (
          <Radio.Group
            size="large"
            className="product-item product-selector__wrapper"
            onChange={(e) => {
              setCheckoutData((prevState) => {
                return {
                  ...prevState,
                  products: [e.target.value],
                  productsEan: [e.target.id],
                };
              });
            }}>
            <SelectorWrapper
              data={arrProducts}
              render={renderElement}
              type="product"
            />
          </Radio.Group>
        )}
      </div>
    </Row>
  );
};

export default ProductSelector;
